<template>
  <div>
    <div v-if="!shouldSelectSingle" class="orderItemsWrapper">
      <div v-for="item in items" class="itemWrapper" :key="item.id">
        <v-checkbox
          v-model="item.value"
          @change="_onUpdateValue"
          :label="`${item.name}`"
        ></v-checkbox>
      </div>
    </div>
    <div v-if="shouldSelectSingle" class="orderItemsWrapper">
      <v-radio-group v-model="radioSelection">
        <v-radio
          class="itemWrapper"
          v-for="item in items"
          :key="item.name"
          :label="item.name"
          :value="item.id"
        ></v-radio>
      </v-radio-group>
    </div>
  </div>
</template>

<script>
  /* eslint-disable */
export default {
  name: "OptionSelector",
  props: {
    items: {
      type: Array,
      default: () => []
    },
    shouldSelectSingle: {
      type: Boolean,
      default: false
    },
    radioSelect: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    radioSelection(val) {
      this.$emit("update:radioSelect", val);
    },
    radioSelect(val) {
      this.radioSelection = val;
    }
  },
  data: () => ({
    radioSelection: true
  }),
  methods: {
    _onUpdateValue() {
      this.$emit("on-update");
    }
  }
};
</script>

<style lang="scss" scoped>
.orderItemsWrapper {
  width: 100%;
  // background-color: red;
  padding: 1rem 2rem;

  * {
    transition: 0.2s;
  }

  .itemWrapper {
    border-bottom: 1px solid grey;
    padding: 4px 10px;

    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
}
</style>
